/**
 * This file is autogenerated by py_nats_stub_gen
 * Do not edit this file manually!!
 * => Instead, re-generate it. Check the py-nats-stub-gen repo for more info
 **/
import type { ApiSubscription, ApiSubscribe } from "../wire/ApiSubscriber";
import type { ConfidenceVoteApiHandler } from "./Handler";
import {
  participantJoinedEventSchema,
  sessionCreatedEventSchema,
  sessionDeletedEventSchema,
  sessionEndedEventSchema,
  voteCastEventSchema,
} from "./schemas";

export const subscribeConfidenceVote: ApiSubscribe<ConfidenceVoteApiHandler> = (
  subscriber,
  variables,
  handler,
) => {
  const subscriptions = new Array<ApiSubscription>();
  if (handler.sessionsCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.confidence_vote.v1.sessions.${sessionId}.sessions.created",
          variables,
          types: { sessionId: String },
        },
        sessionCreatedEventSchema,
        handler.sessionsCreated,
        [],
      ),
    );
  }
  if (handler.sessionEnded) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.confidence_vote.v1.sessions.${sessionId}.sessions.${votingSessionId}.ended",
          variables,
          types: { sessionId: String, votingSessionId: String },
        },
        sessionEndedEventSchema,
        handler.sessionEnded,
        [],
      ),
    );
  }
  if (handler.sessionDeleted) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.confidence_vote.v1.sessions.${sessionId}.sessions.${votingSessionId}.deleted",
          variables,
          types: { sessionId: String, votingSessionId: String },
        },
        sessionDeletedEventSchema,
        handler.sessionDeleted,
        [],
      ),
    );
  }
  if (handler.userCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.confidence_vote.v1.sessions.${sessionId}.sessions.${votingSessionId}.user.created",
          variables,
          types: { sessionId: String, votingSessionId: String },
        },
        participantJoinedEventSchema,
        handler.userCreated,
        [],
      ),
    );
  }
  if (handler.voteCreated) {
    subscriptions.push(
      subscriber.subscribe(
        {
          template:
            "pip.${companyId}.${userId}.${role}.pubsub.confidence_vote.v1.sessions.${sessionId}.sessions.${votingSessionId}.vote.created",
          variables,
          types: { sessionId: String, votingSessionId: String },
        },
        voteCastEventSchema,
        handler.voteCreated,
        [],
      ),
    );
  }
  return subscriptions;
};
